import { Checkbox } from '@upgrowth/react-fulcrum'
import * as React from 'react'

const TermsAndConditionsCheckbox = () => <Checkbox id='termsConditions'
  label={
    <span>Accept <a href="https://www.monash.edu/amigo-terms-of-use#Terms_and_Conditions-1" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://www.monash.edu/amigo-terms-of-use#Community_Guidelines-2" target="_blank" rel="noopener noreferrer">Community Guidelines</a></span>
  }/>
export default TermsAndConditionsCheckbox